// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/attachment.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal CSS */

.addEditQuestionModal {
    max-width: 50rem !important;
}

.addEditQuestionModal-toyota .modal-dialog, .addEditQuestionModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.addEditQuestionModal-lexus .modal-dialog, .addEditQuestionModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.addEditQuestionModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.addEditQuestionModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.redFont {
    color: #e50000;
}

.addEditQuestionModal .css-10nd86i {
    width: 50%;
}

.addEditQuestionModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.addEditQuestionModal-lexus .css-10nd86i svg {
    color: #252525;
}

.addEditQuestionModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.addEditQuestionModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}
.questionLabel{
    /* background-color: #e50000; */
    margin-bottom:0px;
  /*   color:white; */
}

.questionDiv{
    border: 1px lightgray solid;
    padding: 10px;
}
/* .mainQuestionContent {
    min-height: 38rem;
} */
/* .slide >li> div> div{
    padding: 8px 0; 
}  */
  
.attachmentCustomCss { 
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 20px;
    width: 35px; /* Increased the width to match the height */
    background-repeat: no-repeat; 
    background-size: contain; /* This ensures the image is resized to fit the div */
    background-position: center; /* Centers the image within the div */
}
`, "",{"version":3,"sources":["webpack://./src/components/questionnaireModal/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,+BAA+B;IAC/B,iBAAiB;EACnB,mBAAmB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;AACA;;GAEG;AACH;;IAEI;;AAEJ;IACI,yDAA2D;IAC3D,YAAY;IACZ,WAAW,EAAE,4CAA4C;IACzD,4BAA4B;IAC5B,wBAAwB,EAAE,qDAAqD;IAC/E,2BAA2B,EAAE,qCAAqC;AACtE","sourcesContent":["/* Modal CSS */\n\n.addEditQuestionModal {\n    max-width: 50rem !important;\n}\n\n.addEditQuestionModal-toyota .modal-dialog, .addEditQuestionModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.addEditQuestionModal-lexus .modal-dialog, .addEditQuestionModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.addEditQuestionModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.addEditQuestionModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.redFont {\n    color: #e50000;\n}\n\n.addEditQuestionModal .css-10nd86i {\n    width: 50%;\n}\n\n.addEditQuestionModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.addEditQuestionModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.addEditQuestionModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.addEditQuestionModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n.questionLabel{\n    /* background-color: #e50000; */\n    margin-bottom:0px;\n  /*   color:white; */\n}\n\n.questionDiv{\n    border: 1px lightgray solid;\n    padding: 10px;\n}\n/* .mainQuestionContent {\n    min-height: 38rem;\n} */\n/* .slide >li> div> div{\n    padding: 8px 0; \n}  */\n  \n.attachmentCustomCss { \n    background-image: url(\"../../assets/images/attachment.jpg\");\n    height: 20px;\n    width: 35px; /* Increased the width to match the height */\n    background-repeat: no-repeat; \n    background-size: contain; /* This ensures the image is resized to fit the div */\n    background-position: center; /* Centers the image within the div */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
